import React  from 'react';
import { Form, Input, Button } from 'antd'
import style from './style.module.css';
import SuccesfullRequest from '../SuccessfulRequest';
const { TextArea } = Input;
const regExpPhoneNumber = /^[0-9+' ']{1,}[0-9-' ']{3,15}$/;

const RequestForm = ({
    form,
    namePlaceholder,
    email,
    mobile,
    additionalDetailsPlaceholder,
    onSubmitCustomerRequest,
    requiredMessage,
    submitButton,
    successMessage,
    showRequestForm,
    validateEmail }) => {


    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                onSubmitCustomerRequest(values)
            }
        });
    }

    const { getFieldDecorator } = form;
    return (
        <div className={style.templateEditorWrapper}>
            <div className={style.template}>
                {showRequestForm &&
                    <>
                        <Form onSubmit={onSubmit} className={style.requestFormStyle}>
                            <Form.Item className={style.formItem}>
                                <span className={style.fieldLabel}>{namePlaceholder}</span>
                                {getFieldDecorator('customerName', {
                                    rules: [
                                        {
                                            required: true,
                                            message: requiredMessage,
                                        },
                                    ],
                                })(<Input className={style.input} placeholder={namePlaceholder} />)}
                            </Form.Item>
                            <div className={style.fieldRow}>
                                <Form.Item className={style.formItem}>
                                    <span className={style.fieldLabel}>{email} <span className={style.requiredMark}>*</span></span>
                                    {getFieldDecorator('email', {
                                        rules: [
                                            {
                                                type: 'email',
                                                message: validateEmail,
                                            },
                                            {
                                                required: true,
                                                message: requiredMessage,
                                            },
                                        ],
                                    })(<Input className={style.input} placeholder={email} />)}
                                </Form.Item>
                                <Form.Item className={style.formItem}>
                                    <span className={style.fieldLabel}>{mobile}</span>
                                    {getFieldDecorator('mobile', {
                                        rules: [
                                            {
                                                pattern: regExpPhoneNumber,
                                                message: requiredMessage
                                            }
                                        ]
                                    })(<Input className={style.input} placeholder={mobile} />)}
                                </Form.Item>
                            </div>
                            <Form.Item className={style.formItem}>
                                <span className={style.fieldLabel}>{additionalDetailsPlaceholder}</span>
                                {getFieldDecorator('additionalDetails', {
                                    rules: [],
                                })(<TextArea className={style.input} rows={4} placeholder={additionalDetailsPlaceholder} />)}
                            </Form.Item>
                            <Form.Item className={style.formItemSubmitButton}>
                                <Button type="primary" htmlType="submit" className={style.submitButton}>
                                    {submitButton}
                                </Button>
                            </Form.Item>
                        </Form>
                    </>}
                {!showRequestForm && <SuccesfullRequest successMessage={successMessage} />}
            </div>

        </div>
    );
};

const WrappedRequestForm = Form.create({ name: 'customerRequest' })(RequestForm);

export default WrappedRequestForm;
